import { Controller } from "@hotwired/stimulus"
import { TurboBeforeFetchRequestEvent, TurboSubmitStartEvent } from "@hotwired/turbo"
import Confirmation from "../../confirmation"

export default class ScheduledMessagesController extends Controller {
  async confirmCancel(event: TurboBeforeFetchRequestEvent) {
    event.preventDefault()

    if (await Confirmation.confirmCancel("this scheduled message")) {
      event.detail.resume(null)
    }
  }

  appendUrlParams(event: TurboSubmitStartEvent) {
    const urlParams = new URLSearchParams(window.location.search)
    urlParams.forEach((value, key) => {
      event.detail.formSubmission.fetchRequest.body.append(key, value)
    })
  }
}
